/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from "./../lib/httpClient.ts";
import { Response, UploadFileRequestDTO } from "././index.d.ts";

export class File<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Upload File, eg: [ projectReference, artifactFile, artifactReference ]
   *
   * @tags file
   * @name UploadFile
   * @request POST:/file/upload
   * @secure
   */
  uploadFile = (data: UploadFileRequestDTO, params: RequestParams = {}) =>
    this.http.request<Response, Response>({
      path: `/file/upload`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Generate S3 key and presigned URL for file upload
   *
   * @tags file
   * @name GenerateS3Key
   * @request GET:/file/generate-s3-key
   * @secure
   */
  generateS3Key = (
    query: {
      /** The type to upload, eg: [ projectReference, artifactFile, artifactReference ] */
      uploadType: string;
      /**
       * The cycle
       * @format int32
       */
      cycle: number;
      /** The folder id */
      foldId: string;
      /** The name of the file to upload */
      fileName: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<Response, Response>({
      path: `/file/generate-s3-key`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Download File
   *
   * @tags file
   * @name DownloadFile
   * @request GET:/file/download/{fileId}
   * @secure
   */
  downloadFile = (fileId: string, params: RequestParams = {}) =>
    this.http.request<Response, Response>({
      path: `/file/download/${fileId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
